module.exports = __webpack_public_path__ + "002aa917e4ba05dee29f708b829548c6.svg";